import { createFileRoute } from '@tanstack/react-router'
import { RolesListPage } from '../../../features/admin/roles-list-page'

export const Route = createFileRoute('/_app/roles/')({
  component: RolesListPage,
})
